import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Loading from "components/commons/Loading";
import DateAndTimeRangePicker from "components/widget/DateAndTimeRangePicker";
import DateRangePicker from "components/widget/DateRangePicker";


function AbsenceRequestForm({
    onSending = () => { },
    isLoading,
    minDaysNotice
}) {

    const [t, i18n] = useTranslation(["global", "absenceReport"])
    const [dateRange, setDateRange] = useState([null, null]);
    const [reason, setReason] = useState("-");
    const [notes, setNotes] = useState("");
    const [certId, setCertId] = useState("");

    let errors = []

    useEffect(() => {
        if (dateRange[1]) {
            console.log("DateRange picked:" + dateRange)
        }
    }, [dateRange])


    const handleReason = (e) => {
        if (reason == "SICK") {
            setDateRange([])
        }
        setReason(e.target.value)
    }

    const handleNotes = (e) => {
        setNotes(e.target.value)
    }
    const handleCertId = (e) => {
        setCertId(e.target.value)
    }


    if (!dateRange[1]) {
        errors.push("Invalid date range")
    }

    if (!reason || reason == "-") {
        errors.push("Invalid Reason")
    }

    if (reason == "SICK" && certId == "") {
        errors.push("Invalid Reason")
    }

    console.log("Errors:" + errors)

    const handleSending = () => {
        let finalNote = (reason == "SICK") ? `[${t("absenceReport:property.sick_cert_id")}: ${certId}] ${notes}` : notes
        onSending(dateRange, reason, finalNote)
    }


    const renderDateSelector = () => {

        switch (reason) {
            case "PERMIT": return <>
                <label>{t("helper.select_date_time")} <span className="text-muted small">*</span></label><br />
                <DateAndTimeRangePicker
                    dateRange={dateRange}
                    onDateTimePicked={setDateRange}
                    minDaysNotice={0} />
                <br />
            </>
            case "SICK": return <>
                <label>{t("helper.select_date")} <span className="text-muted small">*</span></label>
                < DateRangePicker
                    dateRange={dateRange}
                    onDateRangePicked={setDateRange}
                    minDaysNotice={-30} />
                <br />
                <label>{t("absenceReport:property.sick_cert_id")} <span className="text-muted small">*</span></label><br />
                <input className="p-2" type="text" id="notes" name="notes" rows="4" cols="50" value={certId} onChange={handleCertId} /><br />

            </>
            default: return <>
                <label>{t("helper.select_date")} <span className="text-muted small">*</span></label>
                < DateRangePicker
                    dateRange={dateRange}
                    onDateRangePicked={setDateRange}
                    minDaysNotice={minDaysNotice} />
            </>



        }



    }


    let content = <div className="container">
        <div className="row">
            <div className="col">
                <label htmlFor="cars">{t("absenceReport:property.reason")}:</label><br />

                <select className="p-2" onChange={handleReason} value={reason}>
                    <option value=""> - </option>
                    <option value="HOLIDAY">{t("absenceReport:entity.absence.reason.holidays")}</option>
                    <option value="SICK">{t("absenceReport:entity.absence.reason.sick")}</option>
                    <option value="PERMIT">{t("absenceReport:entity.absence.reason.permitt")}</option>
                    {/* <option value="OTHER">{t("absenceReport:entity.absence.reason.other")}</option> */}
                </select><br />

                <br />

                {/* <>

                    {reason == "PERMIT" ?
                        <>
                            <label>{t("helper.select_date_time")} <span className="text-muted small">*</span></label><br />
                            <DateAndTimeRangePicker
                                dateRange={dateRange}
                                onDateTimePicked={setDateRange}
                                minDaysNotice={minDaysNotice} />
                            <br />

                        </> :
                        <>
                            <label>{t("helper.select_date")} <span className="text-muted small">*</span></label>
                            < DateRangePicker
                                dateRange={dateRange}
                                onDateRangePicked={setDateRange}
                                minDaysNotice={reason == "SICK" ? -30 : minDaysNotice} />
                        </>


                    }

                    {
                        reason == "SICK" &&
                        <>
                            <br />
                            <label>{t("absenceReport:property.sick_cert_id")} <span className="text-muted small">*</span></label><br />
                            <input className="p-2" type="text" id="notes" name="notes" rows="4" cols="50" value={certId} onChange={handleCertId} /><br />
                        </>
                    }

                </> */}

                {renderDateSelector()}


                <br />

                <label htmlFor="notes">{t("property.notes")}:</label><br />
                <textarea id="notes" name="notes" rows="4" cols="50" value={notes} onChange={handleNotes} />
            </div>



        </div>
        <hr></hr>
        {
            isLoading ? <Loading />
                : <div className="row text-center">
                    <div><button className={`btn btn-primary ${errors.length > 0 ? "disabled" : ""}`} onClick={handleSending}>
                        <i className="fa-solid fa-arrow-up-right-from-square"></i> {t("absenceReport:action.send_absence_request")}</button> <button className="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close">{t("action.cancel")}</button>
                    </div>

                </div>
        }


    </div>
    console.log("RENDERING...")
    return content

}

export default AbsenceRequestForm